/**
 * Checks if a string matches the maturity date format DDMMMYY
 * @param value - The string to check
 * @returns True if the string matches the DDMMMYY format (e.g., "19JUN24")
 */
export const isMaturity = (value: string): boolean => {
  const maturityRegex =
    /^\d{2}(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\d{2}$/;

  return maturityRegex.test(value);
};

/**
 * Formats a maturity date string from DDMMMYY format to a more readable format
 * @param maturity - The maturity date string in DDMMMYY format (e.g., "19JUN24")
 * @param isShort - Whether to return a short date format (e.g., "19 Jun")
 * @returns A formatted string with spaces
 */
export const parseMaturity = (maturity: string, isShort = false): string => {
  const month = maturity[2] + maturity.slice(3, 5).toLowerCase();
  const year = maturity.slice(5, 7);
  const day = maturity.slice(0, 2);

  return isShort ? `${day} ${month}` : `${day} ${month} ${year}`;
};
